export default __webpack_public_path__ + "static/media/Warnung.f84743f7.svg";